const API = "https://api.artistnextdoor.in"; ///"https://api.artistnextdoor.in";

export const registerService = `${API}/auth/register`;
export const loginService = `${API}/auth/login`;
export const onboardArtist = `${API}/profile/upsert`;
export const fetchArenaArtists = `${API}/arena/cat/participants`;
export const castVoteForArtist = `${API}/arena/vote`;
export const getActiveContests = `${API}/arena/contests/active`;
export const getAllLeaderboards = `${API}/arena/leaderboards`;
export const participateArenaUrl = `${API}/arena/participate`;
export const getArtistByCategory = `${API}/artist/list`;
export const fetchTestimonials = `${API}/review/testimonials`;
export const fetchTrendingArtist = `${API}/artist/trending`;
export const fetchSpotlightArtist = `${API}/artist/spotlight`;
export const fetchArtistByUsername = `${API}/artist/username/`;
export const fetchArtistDashboardDetailsService = `${API}/bookings/artist-dashboard`;
export const uploadProfilePicture = `${API}/media/upload?isDisplayPicture=true`;
export const uploadPhotoMediaService = `${API}/media/upload`;
export const initiateBookingService = `${API}/bookings/initiate`;
export const bookingActionService = `${API}/bookings`;
export const bookingsByFilterService = `${API}/bookings/bookingFilter`;
export const fetchTransactionsService = `${API}/transaction/fetch`;
export const cancelBookingService = `${API}/bookings/cancel`;
export const getMyProfile = `${API}/profile`;
export const fetchPackages = `${API}/package/artist`;
export const createPackage = `${API}/package/create`;
export const updatePackage = `${API}/package`;
export const deletePackage = `${API}/package`;
export const getNotifications = `${API}/notification/fetch`;
export const getProfilePictue = `${API}/media/file?isDisplayPicture=true&`;
export const markNotificationRead = `${API}/notification/mark-read`;
export const forgotPasswordService = `${API}/auth/forgot`;
export const resetPasswordService = `${API}/auth/reset-pass`;
export const sendEmailOTPService = `${API}/auth/send-otp`;
export const createJobService = `${API}/job/new`;
export const removeJobSerivce = `${API}/job/remove`;
export const getJobsService = `${API}/job/list`;
export const submitJobProposalService = `${API}/job/proposal/new`;
export const removeJobProposalService = `${API}/job/proposal/remove`;
export const getJobProposalService = `${API}/job/proposal/list`;
export const getCategories = `${API}/artist/categories`;
export const acceptProposalService = `${API}/job/proposal/accept`;
export const selfProposalService = `${API}/job/proposal/self`;
export const approveUsersService = `${API}/admin/profiles/approve`;
export const fetchAdminProfilesService = `${API}/admin/profiles`;
